<template>
  <div class="warningcenterRealtimemsgsendIndex" v-loading="pageLoading" element-loading-text="短信发送中,请稍后...">
    <div>
      <div ref="tree" v-loading="loading1">
        <!-- <el-tree
          :data="data"
          show-checkbox
          :default-expanded-keys="idArr"
          node-key="id"
          ref="tree"
          :render-after-expand="false"
          :check-on-click-node="true"
          highlight-current
          @check="getPersonlistByTreeNode"
          :props="defaultProps"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconfile" />
              </svg>
              {{ node.label }}
            </span>
          </span>
        </el-tree> -->
         <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="行政区划/部门" name="first">
              <el-tree
                  :data="data"
                  show-checkbox
                  :default-expanded-keys="idArr"
                  node-key="id"
                  ref="treeDept"
                  :render-after-expand="false"
                  :check-on-click-node="true"
                  highlight-current
                  @check="getPersonlistByTreeNode"
                  :props="defaultProps"
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span>
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconfile" />
                      </svg>
                      {{ node.label }}
                    </span>
                  </span>
                </el-tree>
            </el-tab-pane>
            <el-tab-pane label="群组" name="second">
               <el-tree
                :data="dataGroup"
                show-checkbox
                :default-expanded-keys="idArrGroup"
                node-key="id"
                ref="treeGroup"
                :render-after-expand="false"
                :check-on-click-node="true"
                highlight-current
                @check="getPersonlistByTreeNodeGroup"
                :props="defaultProps"
              >
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#iconfile" />
                    </svg>
                    {{ node.label }}
                  </span>
                </span>
              </el-tree>
            </el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <div>
          <div>
            <div>责任人列表</div>
            <div>
              <el-input
                v-model="query.personName"
                clearable
                placeholder="请输入责任人姓名"
                @change="Global.emptyQuery(query.personName, getPersonList)"
              ></el-input>
              <el-button
                @click="getPersonList"
                type="primary"
                icon="el-icon-search"
                >搜索</el-button
              >
            </div>
          </div>
          <div ref="table">
            <u-table
              v-loading="loading"
              :data="tableData"
              :height="height"
              use-virtual
              :excess-rows="20"
              :row-height="48"
              border
              stripe
              ref="tableContent"
              @selection-change="selectRow"
              style="width: 100%"
              @row-click="rowClick"
            >
              <u-table-column
                type="selection"
                min-width="30"
                align="center"
              ></u-table-column>
              <u-table-column
                prop="personName"
                label="姓名"
                min-width="50"
              ></u-table-column>
              <u-table-column
                prop="adcdName"
                label="部门/行政区划"
                min-width="70"
              ></u-table-column>
              <u-table-column
                prop="personPosition"
                label="岗位/职务"
                min-width="110"
              ></u-table-column>
              <u-table-column
                prop="groupName"
                label="群组"
                min-width="110"
              ></u-table-column>
              <u-table-column
                prop="personPhone"
                label="手机"
                min-width="60"
              ></u-table-column>
            </u-table>
          </div>
        </div>
        <div>
          <div>
            <div>
              <div>短信内容</div>
              <div>
                <el-button
                  @click="selectTemp"
                  icon="el-icon-chat-dot-square"
                  type="primary"
                  plain
                  >选择模板</el-button
                >
              </div>
            </div>
            <div>
              <el-input
                type="textarea"
                :rows="20"
                v-model="msgtext"
                placeholder="请填写短信内容"
              ></el-input>
            </div>
          </div>
          <div>
            <el-input
              type="textarea"
              id="phoneContent"
              placeholder="请输入手机号码，每个手机号码之间必须用逗号分隔或回车分隔"
              v-model="phonetext"
            ></el-input>
          </div>
          <div>
            <el-button @click="reset" type="info"
              >重 &nbsp;&nbsp;&nbsp;&nbsp;置</el-button
            >
            <el-button @click="sendMsg" type="primary"
              >发&nbsp;&nbsp;&nbsp;&nbsp;送</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="短信模板" width="50%" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div class="diaConetnt">
        <div v-for="item in msglist" :key="item.id">
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="item.message"
            placement="top"
          >
            <el-radio v-model="radio1" :label="item.message" border>{{
              item.message
            }}</el-radio>
          </el-tooltip> -->
          <el-radio v-model="radio1" :label="item.message" border>{{
            item.message
          }}</el-radio>
        </div>
        <div class="template" v-if="msglist.length == 0">
            暂无数据
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmdialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import warnTypes from '@/store/types/warningcenter'
export default {
  name: 'realtimemsgsend',
  data () {
    return {
      pageLoading: false,
      loading: false,
      loading1: false,
      msglist: [],
      idArr: [],
      idArrGroup: [],
      radio1: '',
      arr: [],
      height: 10,
      msgtext: '',
      phonetext: '',
      data: [],
      dataGroup: [], // 群组树状数据
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeList: [],
      tableData: [],
      dialogFormVisible: false,
      selectedRows: [],
      query: {
        personName: '',
        adcdList: []
      },
      activeName: 'first' // 默认行政区划
    }
  },
  methods: {
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.$refs['treeGroup'].setCheckedKeys([]) // 行政区划时，清空群组
        this.getPersonlistByTreeNodeGroup()
      } else {
        this.$refs['treeDept'].setCheckedKeys([]) // 群组时，清空行政区划
        this.getPersonlistByTreeNode()
      }
    },
    // 群组树状结构
    getAdcdListTreeGroup () {
      this.loading1 = true
      this.$store.dispatch(warnTypes.GET_ADCDLIST, { isneedjcfx: true, isgroup: true }).then(data => { // 只包含群组
        this.dataGroup = data
        this.dataGroup.forEach(item => {
          this.idArrGroup.push(item.id)
        })
        this.loading1 = false
      })
    },
    getPersonlistByTreeNodeGroup (data, checked) { // 群组树状结构
      this.query.adcdList = []
      if (checked) {
        for (let i = 0; i < checked.checkedNodes.length; i++) {
          const el = checked.checkedNodes[i]
          this.query.adcdList.push({ 'adcdCode': el.adcdCode, 'AdcdLevel': el.level })
        }
      }
      this.getPersonList()
    },
    getAdcdListTree () {
      this.loading1 = true
      this.$store.dispatch(warnTypes.GET_ADCDLIST, { isneedjcfx: false, isgroup: false }).then(data => {
        this.data = data
        this.data.forEach(item => {
          this.idArr.push(item.id)
        })
        this.loading1 = false
      })
    },
    getPersonList () {
      this.loading = true
      this.$store.dispatch(warnTypes.GET_PERSONLIST, this.query).then(data => {
        this.tableData = data.results
        this.loading = false
      })
    },
    sendMsg () {
      let sendPersonList = []
      this.selectedRows.forEach(item => {
        sendPersonList.push({ 'PersonPhone': item.personPhone, 'PersonName': item.personName, 'AdcdCode': item.adcdCode })
      })
      if (this.phonetext) {
        let otherPhone = this.phonetext.replace(/，/g, ',').replace(/\n/g, ',')
        this.phonetext = otherPhone
        let otherPhones = otherPhone.split(',') // 输入框逗号分隔的手机号
        for (let index = 0; index < otherPhones.length; index++) {
          const element = otherPhones[index]
          if (element) {
            if (!(/^1[3456789]\d{9}$/.test(element))) {
              this.$notify.error({
                message: '输入的手机号码有误，请再次确认'
              })
              return
            }
            sendPersonList.push({ 'PersonPhone': element, 'PersonName': '', 'AdcdCode': '' })
          }
        }
      }
      if (this.msgtext === '' || this.msgtext === undefined) {
        this.$notify.error({
          message: '短信内容不能为空'
        })
        return
      }
      if (sendPersonList.length <= 0) {
        this.$notify.error({
          message: '责任人不能为空'
        })
        return
      }
      this.pageLoading = true
      this.$store.dispatch(warnTypes.SENG_MESSAGE, { sendPersonList: sendPersonList, sendTxt: this.msgtext }).then(data => {
        this.pageLoading = false
        if (data.isSuccess === true) {
          this.$notify({
            message: '您已成功发送短信',
            type: 'success'
          })
        } else {
          this.$notify.error({
            message: data.errorMsg
          })
        }
      })
    },
    getPersonlistByTreeNode (data, checked) {
      this.query.adcdList = []
      if (checked) {
        for (let i = 0; i < checked.checkedNodes.length; i++) {
          const el = checked.checkedNodes[i]
          this.query.adcdList.push({ 'adcdCode': el.adcdCode, 'AdcdLevel': el.level })
        }
      }
      this.getPersonList()
    },
    selectTemp () {
      this.dialogFormVisible = true
      this.radio1 = ''
    },
    reset () {
      this.getPersonList()
      this.phonetext = ''
      this.msgtext = ''
    },
    rowClick (row) {
      this.$refs.tableContent.toggleRowSelection(row)
    },
    selectRow (val) {
      this.selectedRows = val
    },
    getMsgTempList () {
      this.$store.dispatch(warnTypes.GET_MSGTEMP_LIST, { pageIndex: '1', pageSize: '100' }).then(data => {
        this.msglist = data.results
      })
    },
    confirmdialog () {
      this.dialogFormVisible = false
      this.msgtext = this.radio1
    }
  },
  mounted () {
    this.getAdcdListTree()
    this.getMsgTempList()
    this.getAdcdListTreeGroup()
    this.Global.elementFix(this, this.$refs['table'], document.getElementById('refline1'), false, (height) => {
      this.height = height
    })
    this.Global.elementFix(this, this.$refs['tree'], document.getElementById('refline2'), false)
    this.Global.elementFix(this, document.getElementById('phoneContent'), document.getElementById('refline4'), false)
  }
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style lang="less" scoped>
.warningcenterRealtimemsgsendIndex {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  & > div:nth-child(n) {
    height: 100%;
  }
  & > div:nth-child(1) {
    display: flex;
    margin-left: 15px;
    & > div {
      padding: 10px;
      background-color: #fff;
    }
    & > div:nth-child(1) {
      overflow-y: scroll;
      width: 400px;
    }
    & > div:nth-child(2) {
      flex-grow: 1;
      display: flex;
      margin-left: 15px;
      margin-right: 15px;
      & > div:nth-child(1) {
        flex-grow: 1;
        width: 100px;
        & > div:nth-child(1) {
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          & > div:nth-child(2) {
            display: flex;
            align-items: center;
            & > div:nth-child(1) {
              margin-right: 5px;
            }
          }
          margin-bottom: 10px;
        }
      }
      & > div:nth-child(2) {
        width: 550px;
        margin-left: 10px;
        & > div:nth-of-type(n + 2) {
          margin-top: 10px;
        }
        & > div:nth-child(1) {
          & > div:nth-child(1) {
            display: flex;
            font-size: 14px;
            align-items: center;
            & > div:nth-child(1) {
              margin-right: 5px;
            }
            margin-bottom: 9px;
          }
        }
        & > div:nth-child(3) {
          display: flex;
          justify-content: center;
          /deep/ .el-button {
            width: 150px !important;
          }
        }
      }
    }
  }
   .diaConetnt {
    & > div:nth-of-type(n + 2) {
      margin-top: 10px;
    }
    .el-radio {
      width: 100%;
      height: 72px;
      overflow: auto;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: normal;
    }
    .template {
      width: 100%;
      height: 72px;
      border: 1px solid gainsboro;
      border-radius: 10px;
      padding:10px;
      text-align: center;
      box-sizing: border-box;
      line-height: 52px;
    }
    *::-webkit-scrollbar {
      width: 0.15rem;
      height: 0.25rem;
      background-color: #ccc;
    }
    *::-webkit-scrollbar-track {
      border-radius: 0.1rem;
      background-color: #ccc;
    }
    *::-webkit-scrollbar-thumb {
      height: 0.2rem;
      border-radius: 0.1rem;
      background-color: #ccc;
    }
  }
}
</style>
